var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D7746",
    d: "M19.5143 0.485651C19.4047 0.376511 19.2661 0.300946 19.115 0.267842C18.9639 0.234737 18.8064 0.245469 18.6612 0.298776L0.78619 6.79878C0.632032 6.85725 0.499312 6.96124 0.405656 7.09693C0.312 7.23262 0.261841 7.39359 0.261841 7.55846C0.261841 7.72334 0.312 7.88431 0.405656 8.02C0.499312 8.15569 0.632032 8.25968 0.78619 8.31815L7.76556 11.105L12.9168 5.93753L14.0624 7.08315L8.88682 12.2588L11.6818 19.2382C11.742 19.3893 11.8462 19.5189 11.981 19.6102C12.1157 19.7015 12.2747 19.7502 12.4374 19.75C12.6016 19.7467 12.761 19.6936 12.8944 19.5979C13.0278 19.5022 13.1291 19.3682 13.1849 19.2138L19.6849 1.33878C19.7403 1.19503 19.7536 1.0385 19.7234 0.887452C19.6932 0.736403 19.6207 0.597053 19.5143 0.485651Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendGreen);
export default __webpack_public_path__ + "static/media/sendGreen.26d362c2.svg";
export { ForwardRef as ReactComponent };